import React, {useEffect} from "react";
import "./style.scss";

import {useDispatch, useSelector} from "react-redux";
import {getPlans} from "../../../store/reducers/accountSlice";
import NewPlans from "./NewPlans";

function NewPlansPage() {
  const dispatch = useDispatch();
  const {idToken} = useSelector((state) => state.auth);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  useEffect(() => {
    dispatch(getPlans({selectedBrand}));
  }, [idToken, selectedBrand, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="funding_eval_container">
      <NewPlans />
    </div>
  );
}

export default NewPlansPage;
